import { VrLessonProgress } from "models/LessonProgress";
import { useGetLessonProgressNodes } from "hooks/useGetLessonProgressNodes";
import { LessonProgressNodes } from "components/views/myTrainings/LessonProgressNodes/LessonProgressNodes";

export const VrLessonProgressSection = (props: { lp: VrLessonProgress; isCompleted: boolean }) => {
    const { lp, isCompleted } = props;
    const { nodes, gettingNodes } = useGetLessonProgressNodes(lp.id);

    return (
        <LessonProgressNodes
            nodes={nodes}
            gettingNodes={gettingNodes}
            completedNodes={lp.completedNodes}
            isCompleted={isCompleted}
        />
    );
};
